import { render } from "./AposColorHue.vue?vue&type=template&id=2b7d8f20&scoped=true"
import script from "./AposColorHue.vue?vue&type=script&lang=js"
export * from "./AposColorHue.vue?vue&type=script&lang=js"

import "./AposColorHue.vue?vue&type=style&index=0&id=2b7d8f20&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7d8f20"],['__file',"color-field/ui/apos/lib/AposColorHue.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b7d8f20"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b7d8f20', __exports__)) {
    api.reload('2b7d8f20', __exports__)
  }
  
  module.hot.accept("./AposColorHue.vue?vue&type=template&id=2b7d8f20&scoped=true", () => {
    api.rerender('2b7d8f20', render)
  })

}


export default __exports__